import React, { Component } from "react";
import PropTypes from "prop-types";
import EuroSymbol from "material-ui-icons/EuroSymbol";
import Done from "material-ui-icons/Done";
import Moment from "moment";
import { connect } from "react-redux";
import { getLatestMessage } from "redux-flash";
import { reduxForm } from "redux-form";
import Button from "material-ui/Button";
import { CircularProgress } from "material-ui/Progress";
import { Link } from "react-router-dom";

import CenteredForm from "../utils/form/CenteredForm";
import {
  cardAddRequest,
  unsubcriptionRequest,
  getPlanRequest,
  getPlanSuccess,
} from "./actions";
import { mountElement, card, createTokens } from "./payment";
import styles from "./subcriber.scss";
import Modal from "../utils/modal/modal";

class Subscriber extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    cardAddRequest: PropTypes.func.isRequired,
    unsubcriptionRequest: PropTypes.func.isRequired,
    admin: PropTypes.shape({
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      user: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
      }),
      subcription: PropTypes.shape({
        accountStatus: PropTypes.shape({
          isTrialExpired: PropTypes.bool,
          isCardAdded: PropTypes.bool,
          isSubscriptionExpired: PropTypes.bool,
          remaningTrialDays: PropTypes.number,
          stripeCurrentPeriodEnd: PropTypes.string,
          isSubscribed: PropTypes.bool,
        }),
      }),
    }).isRequired,
    login: PropTypes.shape({
      authData: PropTypes.shape({
        id: PropTypes.string.isRequired,
        userId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    addCard: PropTypes.shape({
      request: PropTypes.bool,
      unsubcriptionrequest: PropTypes.bool,
    }).isRequired,
    snackbarMessage: PropTypes.objectOf(PropTypes.any).isRequired,
  };
  constructor() {
    super();
    this.state = {
      checkedCGV: false,
      isValidCardDetails: false,
      isModalOpen: false,
      isSendcardAdd: false,
      paymentdetails: {
        cardLastDigit: "",
        cardHolder: "",
        subscriptionType: "1",
        token: "",
        expMonth: "",
        expYear: "",
      },
      selectedOption: "1",
      planPrice: 29,
      stripeError: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.submit = this.submit.bind(this);
    this.handleChangerplan = this.handleChangerplan.bind(this);

    card.addEventListener("change", (event) => {
      const displayError = document.getElementById("card-errors");
      if (event.error) {
        displayError.textContent = event.error.message;
        this.setState({ isValidCardDetails: false });
      } else if (event.empty) {
        this.setState({ isValidCardDetails: false });
      } else {
        this.setState({ isValidCardDetails: true });
        displayError.textContent = "";
      }
    });
    card.addEventListener("submit", (event) => {});
  }
  componentDidMount() {
    this.getPlan();
    if (document.getElementById("root").getElementsByTagName("section")[0]) {
      document
        .getElementById("root")
        .getElementsByTagName("section")[0].hidden = true;
    }
  }
  handleChange(event) {
    //  console.log("ddd--->" + this.state.cardHolder);
    const target = event.target;
    const value = target.value;
    const paymentdetails = this.state.paymentdetails;
    this.setState({
      paymentdetails: {
        ...paymentdetails,
        cardHolder: value,
      },
    });
  }
  handleChangerplan(event) {
    const target = event.target;
    const value = target.checked ? target.value : this.state.selectedOption;
    //  alert(value);
    const paymentdetails = this.state.paymentdetails;
    this.setState({
      paymentdetails: {
        ...paymentdetails,
        subscriptionType: value,
      },
      selectedOption: value,
    });
  }
  unsubcription() {
    const { user } = this.props.admin;
    const { id: accessToken, userId } = this.props.login.authData;
    this.props.unsubcriptionRequest({ accessToken, user });
  }
  submit = () => {
    //  console.log('in submit');
    this.setState({ isSendcardAdd: true });
    const paymentdetails = this.state.paymentdetails;
    console.log("paymentdetails", paymentdetails);
    const { user } = this.props.admin;
    createTokens(user.email)
      .then((source) => {
        this.setState({
          paymentdetails: {
            ...paymentdetails,
            token: source.id,
            expMonth: source.card.exp_month,
            expYear: source.card.exp_year,
            cardLastDigit: source.card.last4,
          },
        });

        const paymentdetails1 = this.state.paymentdetails;
        const { id: accessToken, userId } = this.props.login.authData;

        this.props.cardAddRequest({
          paymentdetails1,
          accessToken,
          userId,
          user,
        });
      })
      .then(() => {
        this.setState({ isModalOpen: false });
        this.setState({ isSendcardAdd: false });
      })
      .catch((err) => {
        let displayError = document.getElementById("card-errors");
        console.log(err);
        displayError.textContent = err.message;
        var message =
          err.code == "card_declined"
            ? "Carte refusée, veuillez réessayer"
            : "Une erreur est survenue, vérifiez votre moyen de paiement";
        this.setState({
          stripeError: message,
          isSendcardAdd: false,
        });
        /*setTimeout(()=>{
                location.reload()
            }, 10000)*/
      });
  };
  openModal() {
    this.setState({
      isModalOpen: true,
      paymentdetails: {
        cardHolder: "",
        subscriptionType: "1",
      },
      selectedOption: "1",
    });
  }
  closeModal(error) {
    this.setState({ isModalOpen: false });
  }
  onOpenModal() {
    mountElement(2);
  }
  getPlan = () => {
    /*this.props.getPlanRequest();*/
    const { user } = this.props.admin;
    console.log("pricing", user.planPrice);
    if (user && user.planPrice) {
      console.log("pricing", user.planPrice);
      this.setState({
        planPrice: user.planPrice,
      });
    }
  };
  render() {
    const {
      handleSubmit,
      snackbarMessage,
      admin: { subcription },
      addCard: { request, unsubcriptionrequest },
    } = this.props;
    const date = Moment(
      subcription.accountStatus.stripeCurrentPeriodEnd
    ).format("DD/MM/YYYY");
    const monthPricing = this.state.planPrice;
    const yearPricing = this.state.planPrice * 10;
    const monthlyYearPricing = Math.ceil((monthPricing * 10) / 12);
    const planName =
      this.props.admin && this.props.admin.user && this.props.admin.user.plan
        ? this.props.admin.user.plan
        : null;
    // const date="31/1/2017";
    return (
      <div className={styles.container1}>
        {!subcription.accountStatus.isCardAdded && (
          <div className={styles.containerWrapper}>
            {subcription.accountStatus.remaningTrialDays <= 0 &&
              !subcription.accountStatus.isSubscribed && (
                <h1 className={styles.pageHeading}>
                  Votre offre gratuite a expiré.
                </h1>
              )}
            {subcription.accountStatus.remaningTrialDays > 0 &&
              !subcription.accountStatus.isSubscribed && (
                <h1 className={styles.pageHeading}>
                  Votre offre gratuite expire dans{" "}
                  {JSON.stringify(subcription.accountStatus.remaningTrialDays)}{" "}
                  jours.
                </h1>
              )}
            <div className={styles.centerDiv}>
              <div className={styles.headingWrapper}>
                <p className={styles.heading}>DIGIDOCTEUR</p>
                <p>
                  <i style={{ textTransform: "uppercase" }}>
                    COMPTE PROFESSIONNEL <b>{planName ? planName : ""}</b>
                  </i>
                </p>
              </div>
              <div
                style={{
                  position: "relative",
                  margin: "50px 0 25px 0",
                }}
              >
                <span className={styles.amount}>{monthlyYearPricing}</span>
                <span className={styles.currencyWrapper}>
                  <sup className={styles.currency}>
                    <EuroSymbol />
                    /mois
                  </sup>
                  <div className={styles.info}>
                    <b>Facturation annuelle</b>
                  </div>
                </span>
                <div
                  style={{
                    fontStyle: "italic",
                  }}
                >
                  ou {monthPricing}
                  <EuroSymbol className={styles.currencySymbol} />
                  /mois facturés mensuellement
                </div>
              </div>
              <div
                style={{
                  marginBottom: "50px",
                }}
              >
                <Button
                  onClick={handleSubmit(() => {
                    this.openModal();
                  })}
                  className={styles.mb7}
                  style={{
                    backgroundColor: "#2196F3",
                  }}
                >
                  S'abonner{" "}
                  {request && (
                    <CircularProgress className={styles.requesting} />
                  )}
                </Button>
              </div>
              <div>
                <p
                  style={{
                    color: "#2196F3",
                  }}
                >
                  Inclus dans l'offre:
                </p>
                <div
                  style={{
                    fontSize: "1.2em",
                  }}
                >
                  <p>
                    <b>Nous créons</b> des vidéos personnalisées pour votre
                    cabinet
                  </p>
                  <p>
                    <b>Nous diffusons</b> vos vidéos en illimité sur vos écrans
                  </p>
                  <p>
                    <b>Vous pouvez gérer</b> ce que vous diffusez en temps réel
                  </p>
                  <p>
                    <b>Vous pouvez choisir</b> vos plages horaires de diffusion
                  </p>
                  <p>
                    <b>Mises à jour</b> gratuites et à vie
                  </p>
                </div>
              </div>
              <div>
                <ul className={styles.listStyle}>
                  <li>
                    <div>
                      <Done />
                      <span>Support technique par email</span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <Done />
                      <span>
                        Ajout de vidéos personnalisées pour les plus pointilleux
                      </span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <Done />
                      <span>
                        Envoyez nous vos powerpoints, nous les diffusons pour
                        vous
                      </span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <Done />
                      <span>
                        Application web "Patient" avec quiz interactifs et
                        ludiques
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
        {subcription.accountStatus.isCardAdded &&
          subcription.accountStatus.isSubscribed && (
            <div className={styles.containerWrapper}>
              <div className={styles.pageHeading}>
                <h1 className={styles.noMargin}>
                  Vous êtes abonné à Digidocteur, félicitations !
                </h1>
                <br />
                <br />
                <span>
                  <i>Prochaine facturation le </i>
                  <span
                    style={{
                      color: "#019cd8",
                    }}
                  >
                    {date}
                  </span>
                </span>
              </div>
              <div
                className={styles.centerDiv1}
                style={{ textAlign: "center" }}
              >
                <div className={styles.r2_c1}>DIGIDOCTEUR</div>
                <br />
                <div className={styles.r2_c2}>
                  Abonnement <b>{planName}</b>
                </div>
                <div className={styles.offerBadge}>
                  <p>Offre Actuelle</p>
                </div>
                <div>
                  <div>
                    <p
                      style={{
                        color: "#2196F3",
                      }}
                    >
                      Inclus dans l'offre:
                    </p>
                    <div
                      style={{
                        fontSize: "1.2em",
                      }}
                    >
                      <p>
                        <b>Nous créons</b> des vidéos personnalisées pour votre
                        cabinet
                      </p>
                      <p>
                        <b>Nous diffusons</b> vos vidéos en illimité sur vos
                        écrans
                      </p>
                      <p>
                        <b>Vous pouvez gérer</b> ce que vous diffusez en temps
                        réel
                      </p>
                      <p>
                        <b>Vous pouvez choisir</b> vos plages horaires de
                        diffusion
                      </p>
                      <p>
                        <b>Mises à jour</b> gratuites et à vie
                      </p>
                    </div>
                  </div>
                  <div>
                    <ul className={styles.listStyle}>
                      <li>
                        <div>
                          <Done />
                          <span>Support technique par email</span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <Done />
                          <span>
                            Ajout de vidéos personnalisées pour les plus
                            pointilleux
                          </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <Done />
                          <span>
                            Envoyez nous vos powerpoints, nous les diffusons
                            pour vous
                          </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <Done />
                          <span>
                            Application web "Patient" avec quiz interactifs et
                            ludiques
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div
                className={styles.centerDiv1}
                style={{
                  textAlign: "center",
                  marginTop: "30px",
                  padding: "20px 20px 50px 20px",
                }}
              >
                <p className={styles.ptage}>Votre carte expire bientôt ?</p>
                <div className={styles.Button}>
                  <Button
                    className={styles.mb7}
                    style={{
                      backgroundColor: "#32506f",
                    }}
                    onClick={() => {
                      this.openModal();
                    }}
                  >
                    Mettre a jour mes informations de paiement &nbsp;{" "}
                    {request && (
                      <CircularProgress className={styles.requesting} />
                    )}
                  </Button>
                </div>
              </div>

              <div
                style={{
                  textAlign: "center",
                  marginTop: "30px",
                  display: "none",
                }}
              >
                <Button
                  className="mr1 mb1"
                  style={{
                    backgroundColor: "lightgrey",
                  }}
                  onClick={() => {
                    this.unsubcription();
                  }}
                >
                  Se désabonner{" "}
                  {unsubcriptionrequest && (
                    <div>
                      &nbsp;
                      <CircularProgress className={styles.requesting} />
                    </div>
                  )}
                </Button>
              </div>
            </div>
          )}{" "}
        <Modal
          isOpen={this.state.isModalOpen && !request}
          onClose={() => this.closeModal()}
          onOpen={() => this.onOpenModal()}
        >
          {" "}
          <br /> <br />{" "}
          <CenteredForm
            title=""
            titcard_holder_namele="Payment Method"
            handleOnSubmit={handleSubmit(this.submit)}
            snackbarMessage={snackbarMessage}
            style={{
              marginTop: "50%",
            }}
          >
            <h2
              style={{
                textAlign: "center",
              }}
            >
              Saisissez vos informations de paiement
            </h2>
            <div className="mb6">
              <br />
              <label htmlFor="fname">Détails de la carte</label>
              <br />
              <div className={styles.cardElement} id="card-element"></div>
              <div
                id="card-errors"
                style={{ fontWeight: "bold", color: "darkorange" }}
                role="alert"
              ></div>
              <br />
              <div>
                <label htmlFor="fname">Nom du titulaire</label>
                <br />
                <input
                  required
                  type="text"
                  id="card_holder_name"
                  name="cardHoldername"
                  value={this.state.paymentdetails.cardHolder}
                  className={styles.input_car_holder}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className={styles.signupBox}>
              <label className={styles.container}>
                <input
                  type="radio"
                  name="palantype"
                  value="1"
                  onChange={this.handleChangerplan}
                  checked={this.state.selectedOption === "1"}
                />
                <span className={styles.checkmark}></span>
                Paiement annuel
              </label>
              <br />
              <br />
              <label className={styles.container}>
                <input
                  type="radio"
                  name="palantype"
                  value="2"
                  onChange={this.handleChangerplan}
                  checked={this.state.selectedOption === "2"}
                />
                <span className={styles.checkmark}></span>
                Paiement mensuel
              </label>
            </div>
            <div>
              {this.state.selectedOption === "1" && (
                <p>
                  {yearPricing}€ prélevés une fois par an
                  <br />
                  <em>
                    soit {monthlyYearPricing}€/mois,{" "}
                    <b>vous économisez {monthPricing * 12 - yearPricing}€</b>
                    <br />
                    <br />
                    <b>
                      Le règlement est 100% sécurisé par{" "}
                      <a href="https://stripe.com">Stripe</a>
                    </b>
                  </em>
                </p>
              )}
              {this.state.selectedOption === "2" && (
                <p>{monthPricing}€ prélevés une fois par mois</p>
              )}
            </div>
            <div className={styles.signupBox}>
              <label className={styles.container}>
                <input
                  type="checkbox"
                  name="cgv"
                  onChange={() => {
                    this.setState({ checkedCGV: !this.state.checkedCGV });
                  }}
                  checked={this.state.checkedCGV}
                />
                <span className={styles.checkmark}></span>
                J'accepte les&nbsp;
                <Link
                  style={{ textDecoration: "underline" }}
                  to={
                    "https://digidocteur.s3.eu-central-1.amazonaws.com/legal/conditions_generales_d_utilisation_digidocteur.pdf"
                  }
                  target="_blank"
                >
                  Conditions générales de vente
                </Link>
              </label>
            </div>
            <div className="row pull-right">
              <Button
                id="add-card"
                className="mr1 mb1 pull-right"
                variant="raised"
                color="primary"
                type="submit"
                disabled={
                  !this.state.checkedCGV ||
                  !this.state.isValidCardDetails ||
                  !this.state.paymentdetails.cardHolder.length
                }
              >
                {!this.stateisSendcardAdd && "S'inscrire"}
                {this.state.isSendcardAdd && (
                  <CircularProgress className={styles.requesting} />
                )}
              </Button>
              <Button
                className="mb1 mr1"
                variant="raised"
                color="secondary"
                onClick={() => this.closeModal()}
              >
                Fermer
              </Button>
            </div>
            <div
              style={{
                fontWeight: "bold",
                color: "darkorange",
                marginTop: "125px",
                textAlign: "center",
                width: "100%",
              }}
            >
              {this.state.stripeError}
            </div>
          </CenteredForm>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  plan: state.plan,
  login: state.login,
  admin: state.admin,
  addCard: state.addCard,
  snackbarMessage: getLatestMessage(state) || {},
});
const ConnectedAddCard = connect(mapStateToProps, {
  getPlanRequest,
  getPlanSuccess,
  cardAddRequest,
  unsubcriptionRequest,
})(Subscriber);
export default reduxForm({ form: "addcard" })(ConnectedAddCard);



// WEBPACK FOOTER //
// ./src/pages/subscription/subscriber.jsx